import CreditScorePage from "components/pages/CreditScorePage";

export default function CaptureCreditScoreScore(props) {
    return <CreditScorePage />
}